export default {
    namespaced: true,

    state: {
        users: [
            { id: 1, name: "Василий Иванов", avatar: "https://i.pravatar.cc/34?img=1" },
            { id: 2, name: "Александр Константинопольский", avatar: "https://i.pravatar.cc/34?img=2" },
            { id: 3, name: "Николаев Николай Николаевич", avatar: "https://i.pravatar.cc/34?img=3" },
            { id: 4, name: "Сергеев Сергей Сергеевич", avatar: "https://i.pravatar.cc/34?img=4" },
            { id: 5, name: "Иванов Иван Иванович", avatar: "https://i.pravatar.cc/34?img=5" },
            { id: 6, name: "Петров Петр Петрович", avatar: "https://i.pravatar.cc/34?img=6" },
            { id: 7, name: "Николаев Николай Николаевич", avatar: "https://i.pravatar.cc/34?img=7" },
            { id: 8, name: "Сергеев Сергей Сергеевич", avatar: "https://i.pravatar.cc/34?img=8" },
        ],

        filters: [
            { id: 1, name: "Первый фильтр", authorId: 1, value: "", users: [2]},
            { id: 2, name: "Второй фильтр", authorId: 2, value: "", users: [1]},
            { id: 3, name: "Третий фильтр", authorId: 1, value: "", users: []}
        ],

        currentUserId: 2,
    },

    getters: {
        getUsers: state => state.users,

        getFilters: state => state.filters,

        getCurrentUserId: state => state.currentUserId,

        getFilterById: state => id => state.filters.find(f => f.id === id),
    }
};
